<app-header></app-header>

<div class="container-fluid bg-primary py-5 bg-header mrb-90">
    <div class="row py-5">
        <div class="col-12 pt-lg-5 mt-lg-5 text-center">
            <h1 class="display-4 text-white">About Us</h1>
            <a routerLink="/" class="h5 text-white">Home</a>
            <i class="far fa-circle text-white px-2"></i>
            <a routerLink="/about-us" class="h5 text-white">About</a>
        </div>
    </div>
</div>

<!-- About Start -->
<div class="container-fluid py-5">
    <div class="container py-5">
        <div class="row g-5">
            <div class="col-lg-7">
                <div class="section-title position-relative pb-3 mb-5">
                    <h5 class="fw-bold text-primary text-uppercase">About Us</h5>
                    <h1 class="mb-0">Empowering Brands with Creative & Digital Excellence</h1>
                </div>
                <p class="mb-4">We're a creative agency focused on branding, UI/UX, and digital storytelling. From concept to
                    execution, we design experiences that connect and inspire. Our team crafts solutions that are both visually
                    stunning and performance-driven.</p>
                <div class="row g-0 mb-3">
                    <div class="col-sm-6">
                        <h5 class="mb-3"><i class="bi bi-award text-primary me-3"></i>Design Awards</h5>
                        <h5 class="mb-3"><i class="bi bi-people text-primary me-3"></i>Creative Team</h5>
                    </div>
                    <div class="col-sm-6">
                        <h5 class="mb-3"><i class="bi bi-lightning-charge text-primary me-3"></i>Fast Delivery</h5>
                        <h5 class="mb-3"><i class="bi bi-cash-coin text-primary me-3"></i>Transparent Pricing</h5>
                    </div>
                </div>
                <div class="d-flex align-items-center mb-4">
                    <div class="bg-primary d-flex align-items-center justify-content-center border-radius"
                        style="width: 60px; height: 60px;">
                        <i class="bi bi-telephone-fill text-white fs-5"></i>
                    </div>
                    <div class="ps-4">
                        <h5 class="mb-2">Call Us to Start Your Project</h5>
                        <h4 class="text-primary mb-0">+1 234 5577889</h4>
                    </div>
                </div>
                <a routerLink="/contact" class="btn btn-primary border-radius py-3 px-5 mt-3">Get a Quote</a>
            </div>

            <div class="col-lg-5" style="min-height: 500px;">
                <div class="position-relative h-100">
                    <img class="position-absolute w-100 h-100 border-radius" src="assets/images/about.jpg" style="object-fit: cover;" alt="about-img">
                </div>
            </div>
        </div>
    </div>
</div>
<!-- About End -->

<!-- Team Start -->
<div class="container-fluid py-5">
  <div class="container py-5">

    <div class="section-title text-center position-relative pb-3 mb-5 mx-auto" style="max-width: 600px;">
      <h5 class="fw-bold text-primary text-uppercase">Team Members</h5>
      <h1 class="mb-0">Meet the Creative Minds Behind Our Success</h1>
    </div>

    <div class="row g-5">

      <div class="col-lg-4" *ngFor="let member of teamMembers; let i = index" [attr.data-wow-delay]="(i+1)*0.3 + 's'">

        <div class="team-item bg-light border-radius overflow-hidden">

          <div class="team-img position-relative overflow-hidden">

            <img class="img-fluid w-100"
                 [src]="'assets/images/' + member.image"
                 [alt]="member.name">

            <div class="team-social">

              <a *ngFor="let social of member.socials"
                 class="btn btn-lg btn-primary btn-lg-square border-radius"
                 [href]="social.link">

                <i [class]="social.icon + ' fw-normal'"></i>

              </a>

            </div>

          </div>

          <div class="text-center py-4">
            <h4 class="text-primary">{{member.name}}</h4>
            <p class="text-uppercase m-0">{{member.role}}</p>
          </div>

        </div>

      </div>

    </div>

  </div>
</div>
<!-- Team End -->

<!-- Brands Start -->
<div class="container-fluid">
    <div class="container py-5 mb-5">
        <div class="bg-white">
            <owl-carousel-o [options]="brandsCarousel" class="owl-btn-center-lr vendor-carousel">
                <ng-template carouselSlide *ngFor="let brand of brandStore">
                    <div class="client-box">
                        <a href="#."><img src="assets/images/{{brand.img}}" alt="brand-img"></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</div>
<!-- Brands End -->

